import { render, staticRenderFns } from "./slider-skeleton.vue?vue&type=template&id=11f68ec2&scoped=true&"
import script from "./slider-skeleton.vue?vue&type=script&lang=js&"
export * from "./slider-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./slider-skeleton.vue?vue&type=style&index=0&id=11f68ec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f68ec2",
  null
  
)

export default component.exports